import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {isMobileDevice} from "../../Utils/Utils";

interface SidebarState {
  isMobile: boolean;
}

const initialState: SidebarState = {
  isMobile: isMobileDevice(),
};

export const deviceChange = createSlice({
  name: "device",
  initialState,
  reducers: {
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },
  },
});

export const { setIsMobile } = deviceChange.actions;

export default deviceChange.reducer;
